import { UserRole, type UserWithProfile } from '@klaro7/shared-types';

/** Standalone route that hosts the blocking OTP step. */
export const PHONE_VERIFICATION_PATH = '/verifica-telefono';

/**
 * Roles that cannot use the app without a verified phone number.
 * Users must verify to place calls/chats, professionals to go online — admins
 * are never gated (they must stay able to operate the platform).
 */
const GATED_ROLES: UserRole[] = [UserRole.USER, UserRole.PROFESSIONAL];

/**
 * True when the logged-in account must complete phone verification before it
 * can access any authenticated surface.
 *
 * Chi salta l'OTP in registrazione (o lo abbandona a metà) atterra qui al
 * login successivo: il codice viene rigenerato in quel momento e vale 10
 * minuti, quindi non serve conservare nulla della sessione di registrazione.
 */
export function needsPhoneVerification(user: UserWithProfile | null | undefined): boolean {
  if (!user) return false;
  if (!GATED_ROLES.includes(user.role)) return false;
  return user.profile?.phoneVerified !== true;
}
